module.exports = __webpack_public_path__ + "static/media/whitelogo.4a972825.png";